var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificatonBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "42px",
    height: "46px",
    viewBox: "0 0 42 46",
    style: {
      enableBackground: "new 0 0 42 46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#0662B9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell_1",
    transform: "translate(0 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bell_1_Background_Mask_",
    className: "st0",
    d: "M0-13h42v42H0V-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st1",
    d: "M35,11V4.5c0-7.7-6.3-14-14-14S7-3.2,7,4.5V11l-3.2,4.8c-0.5,0.8-0.3,1.9,0.5,2.4 c0.3,0.2,0.6,0.3,1,0.3h31.5c1,0,1.8-0.8,1.7-1.8c0-0.3-0.1-0.7-0.3-1l0,0L35,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    className: "st1",
    d: "M25.3,24c1.2-1,2.1-2.3,2.5-3.8H14.2c0.4,1.5,1.3,2.8,2.5,3.8s2.7,1.5,4.3,1.5l0,0 C22.6,25.5,24.1,25,25.3,24z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificatonBlue);
export default __webpack_public_path__ + "static/media/notificaton-blue.f75c1b0dcdb394f191e471ee35b41bef.svg";
export { ForwardRef as ReactComponent };